/**
 * Shared internal query-key helpers used by more than one domain module.
 * Internal — NOT re-exported by the `@barel/api-client/react` barrel, so
 * these stay off the public surface.
 */
export const conversationKey = (id: string) => ['conversation', id] as const;
